import {ReportDetail} from 'models/Reports'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'

interface Props {
 open: boolean
 onClose: () => void
 details: ReportDetail[]
 reportKey: string
}
interface Stakeholder {
 sub_type: string
 sub_type_display_name?: string | null
 filter_url?: string
}

export default function StakeholderModal({
 open,
 onClose,
 details,
 reportKey,
}: Props) {
 const [selected, setSelected] =
  useState<Stakeholder | null>(null)
 const [isOpen, setIsOpen] = useState(false)
 const {t} = useTranslation()
 const navigate = useNavigate()

 useEffect(() => {
  if (open) {
   setIsOpen(false)
   setSelected(null)
  }
 }, [open])

 if (!open) return null

 const handleContinue = () => {
  if (!selected) return

  const subType = selected.sub_type

  navigate(
   `/quick-links/reports?report_key=${reportKey}&sub_type=${subType}&page=1&page_size=1000`,
   {
    state: {
     details: details,
     selectedStakeholder: selected,
    },
   }
  )

  onClose()
 }

 return (
  <div className='fixed inset-0 bg-black/40 flex items-center justify-center z-50'>
   <div className='bg-white w-[620px] rounded-[18px] p-8 relative shadow-xl'>
    <button
     onClick={onClose}
     className='absolute right-6 top-6 flex h-10 w-10 items-center justify-center rounded-full bg-[#E9ECEF]'
    >
     ✕
    </button>

    <h2 className='text-[28px] font-semibold mb-8'>
     {t('reports.ChooseAUser')}
    </h2>

    <div className='relative w-full'>
     <div
      onClick={() => setIsOpen(!isOpen)}
      className={`relative border rounded-[12px] h-[64px] px-4 pt-6 pb-2 cursor-pointer
      ${isOpen ? 'border-[#4E83E4]' : 'border-[#E4E6EF]'}`}
     >
      <label className='absolute left-4 top-2 text-[13px] text-[#4E83E4]'>
       {t('reports.StakeholderCategory')}
       <span className='text-red-500'>*</span>
      </label>

      <span
       className={`${
        selected ? 'text-[#3F4254]' : 'text-[#9AA0A6]'
       }`}
      >
       {selected?.sub_type_display_name ||
        t('reports.StakeholderCategory')}
      </span>

      <div className='absolute right-4 top-[50%] -translate-y-1/2'>
       <svg
        width='18'
        height='18'
        viewBox='0 0 20 20'
        fill='none'
        className={`transition ${
         isOpen ? 'rotate-180' : ''
        }`}
       >
        <path
         d='M5 7L10 12L15 7'
         stroke='#6B7280'
         strokeWidth='2'
         strokeLinecap='round'
        />
       </svg>
      </div>
     </div>

     {isOpen && (
      <div className='absolute left-0 w-full bg-[#F5F7FA] border border-[#E4E6EF] border-t-0 rounded-[12px] shadow-md'>
       {details.map((item, index) => (
        <label
         key={index}
         className='flex items-center gap-3 px-4 py-4 border-b last:border-0 cursor-pointer'
        >
         <input
          type='radio'
          name='stakeholder'
          checked={selected?.sub_type === item.sub_type}
          onChange={() => {
           setSelected(item)
           setIsOpen(false)
          }}
          className='w-5 h-5 accent-[#4E83E4]'
         />

         <span className='text-[15px] text-[#3F4254]'>
          {item.sub_type_display_name || item.sub_type}
         </span>
        </label>
       ))}
      </div>
     )}
    </div>

    <button
     onClick={handleContinue}
     className={`w-full h-[48px] rounded-[10px] mt-10 text-[16px] font-medium
      ${
       selected
        ? 'bg-[#4E83E4] text-white'
        : 'bg-[#E5E7EB] text-[#9CA3AF]'
      }`}
    >
     {t('reports.Continue')}
    </button>
   </div>
  </div>
 )
}
